<template>
  <div class="car-info"
       style="height:calc(100vh - 110px)">
    <div class="search-result flex-valign">
      <div style="font-weight:bolder;">
        <div style="margin:10px;cursor:pointer;padding-top:5px"
             @click="back"
             class="iconfont-lunan icon-lunan-uf-icon-back1">
          返回
        </div>
        <div style="margin:20px 0 10px 15px;">车辆信息</div>
      </div>
      <div class="searchList">
        <div style="flex:1;">
          <img :src="imgPath(carDetailsList)"
               class="image"
               onerror="this.src='/images/theme/newDark/default.png'"
               style="width:110px;height:110px">
        </div>
        <div style="flex:3;">
          <div style="margin:10px;color:#fff;padding-left:5px">
            <span style="color:#95a6c1">车主： </span>
            <span>{{carDetailsList.ownerName?carDetailsList.ownerName:'未知车辆'}}</span>
          </div>
          <div style="margin:10px;color:#fff;padding-left:5px">
            <span style="color:#95a6c1">车牌： </span>
            <span>{{carDetailsList.plateCode}}</span>
          </div>
          <div style="margin:10px;color:#fff;padding-left:5px">
            <span style="color:#95a6c1">类型： </span>
            <span>{{carDetailsList.vehicleTypeName}}</span>
          </div>
          <div style="margin:10px;color:#fff;padding-left:5px">
            <span style="color:#95a6c1">颜色： </span>
            <span>{{carDetailsList.vehicleColorName}}</span>
          </div>
        </div>
      </div>
    </div>
    <div style="margin:5px 15px;height:calc(2vh)">行走轨迹</div>
    <div style="height:calc(58vh);overflow:auto;padding-bottom:10px">
      <div v-for="(item,index) in carDetailsList.dateList"
           :key="index"
           @click.stop="getTrajectory(item,index)"
           :class="['trajectoryId'+index,'trajectoryList']">
        <div style="display:flex;justify-content:space-between;width:100%;margin-bottom:10px;font-size:12px">
          <div>
            <span>时间：</span>
            <span>{{item.date}}</span>
          </div>
          <span :class="item.isPeopleShow ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"></span>
        </div>
        <!-- <div style="margin-top: 15px;width:100%"> -->
        <!-- <div v-for="(val,indexIner) in item.trailList"
             :key="indexIner"
             :class="'trackPerson-detail '+(item.isPeopleShow ? 'expand' : 'collspand')">
          <div v-if="indexIner<moreList[index]['flg']"
               style="width:100%">
            <div style="width:100%">
              <div class="trackPerson-detail-img">
                <img :src="val.rimageUrl"
                     alt=""
                     style="width: 100%;height: 100%;position: absolute; top: 0;left: 0;">
                <input type="checkbox"
                       :name="item.date+indexIner"
                       @click="changeCheckbox($event,val,item.date,indexIner)"
                       style="position:absolute;top:5px;right:5px">
              </div>
              <div>
                <div style="text-align:center;padding-top:10px;margin-bottom:10px">{{val.time}}</div>
              </div>
            </div>
          </div>
        </div> -->
        <!-- </div> -->
        <div v-for="(val, indexIner) in item.trailList"
             :key="indexIner"
             :class="'trackPerson-detail ' + (item.isPeopleShow ? 'expand' : 'collspand')">
          <div v-if="indexIner < moreList[index]['flg']"
               style="width:100%">
            <div style="width:100%">
              <div class="trackPerson-detail-img"
                   :key="key">
                <img :src="imgPath(val.rimageUrl)"
                     alt=""
                     @click.stop="handlePositon(val)"
                     onerror="this.src='/images/theme/newDark/default.png'"
                     style="width: 59px;height: 59px;position:absolute;top:0px;left:0px" />
                <input type="checkbox"
                       :name="item.date + indexIner"
                       @click.stop="changeCheckbox($event, val, item.date, indexIner)"
                       style="position:absolute;top:0px;right:0px" />
              </div>

              <div>
                <div style="text-align:center;padding-top:10px;margin-bottom:10px;font-size:12px">{{ val.time }}</div>
              </div>
            </div>
          </div>
        </div>
        <div v-if="moreList[index]['length']>moreList[index]['flg']"
             @click.stop="getMoreList(index)"
             :class="'more-list '+(item.isPeopleShow ? 'expand' : 'collspand')">查看更多</div>
      </div>
    </div>
  </div>
</template>

<script>
import { Dic, Bus, Dates } from '$utils'
// import appCamersGroup from '@components/app-camera-group'
// import trackDetail from '@src/components/business/app-track-detail/track-detail.vue'
import { api } from '../api'
export default {
  components: {
    // appCamersGroup,
    // trackDetail
  },
  data () {
    return {
      changeAllChecked: true,
      allChecked: true,
      getJson: false,
      dateTime: '',
      dateTimeFlag: false,
      copyCheckboxGroupListIndex: 0,
      copyCheckboxGroupList: [],
      changeGroup: '',
      changeGroupIndex: 0,
      checkboxGroupList: [],
      moreList: [],
      carDetailsList: {},
      main: true,
      trackData: {},
      searchDataList: [],
      formListData: {
        plateCode: this.$route.params.plateCode ? this.$route.params.plateCode : '',
        area: [],
        areaName: [],
        startTime: Dates.parse(Dates.format((new Date).getTime() - 24 * 60 * 60 * 1000)),
        endTime: Dates.parse(Dates.format(new Date()))
      },
      showTreeList: false,
      fileList: [], // 上传图片数组
      treeData: [],
      imgFileList: [], // 保存名单中上传图片数组
      visibleRight: true,
      checkedGroup: [],

    };
  },
  watch: {
    imgFileList: {
      handler (newValue, oldValue) {
        this.formData.fileList = newValue
      },
      deep: true
    },
    fileList: {
      handler (newValue, oldValue) {
        this.formData.fileList = newValue
      },
      deep: true
    },
    dateTime: {
      handler (newValue, oldValue) {
        this.dateTimeFlag = true;
      },
      deep: true
    },
    changeGroup: {
      handler (newValue, oldValue) {
        if (oldValue) {
          // console.log('changeGroup____')
          this.getJson = true
          let byName = newValue + this.changeGroupIndex
          $("input[name='" + byName + "'").prop('checked', true);
        }
      },
      deep: true
    },
  },
  beforeDestroy () {
  },
  mounted () {

  },
  methods: {
    // 判断上传文件个数
    fileCount (file, fileList) {
      this.$message.warning(this.$t('personMg.message.upWarn'))
    },
    // 添加图片
    changeFile (file, fileList) {
      console.log('fileList', fileList)
      if (!this.validImg(file)) {
        this.deleteImg(file, fileList)
        return false
      }
      this.imgFileList = fileList
    },
    deleteImg (file, fileList) {
      if (this.formState === 2) {
        if (file.status === 'update') {
          let index = this.fileList.findIndex(item => {
            return item.url === file.url
          })
          this.fileList.splice(index, 1)
        } else {
          let index = this.fileList.findIndex(item => {
            return item.url === file.url
          })
          fileList.splice(index, 1)
        }
      } else {
        let index = this.fileList.findIndex(item => {
          return item.url === file.url
        })
        fileList.splice(index, 1)
      }
    },
    validImg (file) {
      const fileName = file.name;
      const type = fileName.slice(fileName.indexOf('.') + 1, fileName.length);
      const imgArr = ['jpg', 'png', 'jpeg', 'jpe', 'dib', 'bmp', 'JPG', 'PNG', 'JPEG', 'JPE', 'DIB', 'BMP'];
      let isJPG = null;
      imgArr.indexOf(type) === -1 ? isJPG = false : isJPG = true;

      if (!isJPG) {
        this.$message.error(this.$t('personMg.message.formatWarn'));
        return false
      }
      const Size = 1024 * 1024 * 1
      if (file.size > Size) {
        this.$message.error(this.$t('personMg.message.sizeWarn'))
        return false
      }
      return true
    },
    // 删除图片
    removeFile (file, fileList) {
      if (this.formState === 2) {
        if (file.status === 'update') {
          let index = this.fileList.findIndex(item => {
            return item.url === file.url
          })
          this.fileList.splice(index, 1)
        }
      }
      this.imgFileList = fileList
    },
    imgPath (item) {
      return item ? Bus.imgPath(item.fileCode) : ""
    },
    carDetails (item) {
      this.changeGroup = item.dateList[0].date
      this.moreList = [];
      // console.log('dateList',item.dateList);
      item.dateList.map((val, index) => {
        this.moreList.push({
          length: val.trailList.length,
          flg: 4
        })
        this.$set(val, 'isPeopleShow', false);
      })
      this.carDetailsList = item;
      this.carDetailsList.dateList[0].isPeopleShow = true
      this.main = false;
      this.$nextTick(() => {
        this.getTrajectory(item.dateList[0], '0')
      })
    },
    back () {
      this.$parent.main = true;
      this.carDetailsList = [];
      this.$map.MapInstance2D.clear();
    },
    handlePositon (val) {
      this.$map.MapInstance2D.setMapCenter([val.longitude, val.latitude])
    },
    changeCheckbox (event, val, date, index) {
      let name_ = date + index
      let checkboxFlag = document.getElementsByName(name_)
      // console.log('checkboxFlag[0].checked', checkboxFlag[0].checked, val)
      // console.log(checkboxFlag)
      // console.log(val)
      if (checkboxFlag[0].checked) {
        // 选中
        this.copyCheckboxGroupList.push(val)
        this.checkIdList.push(val.fullTime)
      } else {
        // 取消选中
        let spliceIndex = this.checkIdList.indexOf(val.fullTime)
        this.copyCheckboxGroupList.splice(spliceIndex, 1)
        this.checkIdList.splice(spliceIndex, 1)
      }
      // console.log(this.copyCheckboxGroupList)
      this.showDrawTrajectory(this.copyCheckboxGroupList)
    },
    getTrajectory (item, id) {
      this.TrackImgShow(id)
      this.copyCheckboxGroupList = []
      this.checkIdList = []
      let domId = 'trajectoryId' + id
      let allBorder = document.getElementsByClassName('trajectoryList')
      let changeBorder = document.getElementsByClassName(domId)[0]
      for (let i = 0; i < allBorder.length; i++) {
        allBorder[i].style.border = 'none'
      }
      this.showDrawTrajectory(item.trailList)
      this.key += 1
    },
    filterTime (time) {
      // var date = '2015-03-05 17:59:00.0';
      let date = time.substring(0, 19);
      date = date.replace(/-/g, '/'); //必须把日期'-'转为'/'
      return new Date(date).getTime();
    },
    // 绘制轨迹信息 气泡yhjadd
    showDrawTrajectory (item) {
       let drawItem = JSON.parse(JSON.stringify(item))
      // 时间排序
      drawItem.sort((a, b) => {
        a.showTime = this.filterTime(a.fullTime)
        var x = 'showTime'
        var value1 = a[x];
        var value2 = b[x];
        return value1 - value2;
      })
      // 移除地图轨迹
      this.$map.MapInstance2D.removeTrajectory()
      this.$map.MapInstance2D.closeTips()
      // 设置地图点位
      let setPoint = []
      let src = ''
      //合并相同项
      let dataInfo = {};
      drawItem.forEach((data, index) => {
        data.trajectoryType = 'vehicle'
        let { longitude } = data;
        let { latitude } = data;
        if (!dataInfo[longitude] && !dataInfo[latitude]) {
          dataInfo[longitude] = {
            data,
            child: []
          }
        }
        dataInfo[longitude].child.push(data);
      });

      let list = Object.values(dataInfo);
      list.map((val, index) => {
        if (index === 0) {
          src = './images/theme/newDark/map/state.png'
        } else if (index === (list.length - 1)) {
          src = './images/theme/newDark/map/end_point.png'
        } else {
          src = './images/theme/newDark/map/car.png'
        }
        setPoint.push({
          point: (() => {
            let ary = []
            ary.push(val.data.longitude)
            ary.push(val.data.latitude)
            ary.push(src)
            ary.push(val.child.length > 1 ? val.child : val.child[0])
            return ary
          })(val),
        })
      })
      setPoint.length ?
        this.$map.MapInstance2D.setMapCenter(setPoint[setPoint.length - 1].point) :
        this.$map.MapInstance2D.setMapCenter()
      this.$map.MapInstance2D.drawTrajectory(setPoint, 1)
    },
    resetFrom () {
      this.searchDataList = [];
      this.formListData.plateCode = '';
      this.formListData.startTime = Dates.parse(Dates.format((new Date).getTime() - 24 * 60 * 60 * 1000));
      this.formListData.endTime = Dates.parse(Dates.format(new Date()));
      this.formListData.areaName = [];
      this.$refs['ruleForm'].resetFields();
      this.clearTree();
      this.$map.MapInstance2D.clear();
    },
    handleVisible () {
      if (this.visibleRight) {
        this.visibleRight = false;
      } else {
        this.visibleRight = true;
      }
    },
    initPage () {
      console.log('执行初始化地图')
    },
    clearTree () {
      this.$refs['areaTree'].resetTreeData();
    },
    getMoreList (index) {
      this.moreList[index]['flg'] += 4;
    },
    TrackImgShow (index) {
      let isPeopleShow = this.carDetailsList.dateList[index].isPeopleShow;
      this.carDetailsList.dateList.map(val => {
        val.isPeopleShow = false
      })
      this.carDetailsList.dateList[index].isPeopleShow = !isPeopleShow;
      this.moreList[index]['flg'] = 4;
      this.checkedGroup = []
    },
  }
};
</script>
<style lang="scss">
@import "../style/carSearch.scss";

.car-info {
  .search-result {
    flex: 1 1 auto;
    margin-top: 15px;
  }
  .contraction-bar {
    position: relative;
    overflow: hidden;
    width: 100%;
    .vehicle-to {
      background-color: #1a1f2b;
      opacity: 0.8;
      position: absolute;
      right: 0;
      z-index: 2;
      &.expand {
        width: 350px;
      }
      &.collspand {
        display: none;
      }
    }
  }
  .arrow-left-span {
    width: 16px;
    background: rgba(26, 31, 43, 0.8);
    position: absolute;
    z-index: 2;
    height: 64px;
    // right: calc(26vw);
    top: calc(50% - 32px);
    border-bottom-left-radius: 16px;
    border-top-left-radius: 16px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    cursor: pointer;

    &.expand {
      right: calc(26vw);
    }
    &.collspand {
      right: 0;
    }
  }
  .search-title {
    padding-left: 10px;
    @include set_theme_color(color, font-default-color);
  }
  .el-dialog {
    width: 25%;
  }
}
</style>